//RTK
import { createSlice } from "@reduxjs/toolkit";

//Local imports
import { dispatch } from "store";
import toast from "utils/ToastNotistack";
import T from "utils/constants/T";

import authApi from "interceptor/authInterceptor";
import v1Api from "interceptor/oldApiInterceptor";

//types
export type payrollSettingsTabProps = {
  deductionFileCategories: any[];
  loader: boolean;
  error: null;
};
//initial state
const initialState: payrollSettingsTabProps = {
  deductionFileCategories: [],
  loader: false,
  error: null,
};
// ==============================|| SLICE - Payroll Settings Tab ||============================== //
const payrollSettingsTabData = createSlice({
  name: "payrollSettingsTabData",
  initialState,
  reducers: {
    getPayrollSettingsTabData(state, action) {
      let { deductionFileCategories } = action.payload;
      state.deductionFileCategories =
        deductionFileCategories || initialState.deductionFileCategories;
    },
    isLoading(state, action) {
      state.loader = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload;
    },
    clearPayrollSettings: (state) => initialState,
  },
});
export default payrollSettingsTabData.reducer;

export const {
  getPayrollSettingsTabData,
  isLoading,
  hasError,
  clearPayrollSettings,
} = payrollSettingsTabData.actions;

// ==============================|| SLICE - Get Payroll Settings Details ||============================== //

export function fetchPayrollSettingsTabData(
  selectedCompanyId: string,
  systemPayrollCode: string
) {
  return async () => {
    const response = await authApi.get(
      `/v2/api/companies/${selectedCompanyId}/payroll?code=${systemPayrollCode}`
    );
    if (response.data) {
      const finalData = response.data.data;
      if (systemPayrollCode === T.KEYPAY.toUpperCase()) {
        dispatch(
          getPayrollSettingsTabData({
            deductionFileCategories: finalData,
          })
        );
      }
    }
  };
}

// ==============================|| SLICE - Save Payroll Settings ||============================== //

export function savePayrollSettingsTabData(
  payload: any,
  selectedCompanyId: string,
  navigator: any
) {
  return async () => {
    const response = await authApi.put(
      `/v2/api/companies/${selectedCompanyId}/payroll`,
      payload
    );
    if (response.data) {
      toast(T.PAYROLL_SETTINGS_UPDATED_SUCCESSFULLY, { variant: "success" });
      navigator("/companyDetails/payrollSettings/view");
    }
  };
}


// ==============================|| SLICE - Sync Payroll Settings ||============================== //

export function syncPayroll(
  selectedCompanyId: string
) {
  return async () => {
    const response = await authApi.post(
      `/v2/api/companies/${selectedCompanyId}/syncPayroll`
    );
    if (response.data) {
      toast(T.SYNCED_SUCCESSFULLY, { variant: "success" });
    }
  };
}

// ==============================|| SLICE - Sync MYOBADVANCED Payroll Settings ||============================== //

export function syncMYOBPayroll(
  selectedCompanyId: string
) {
  return async () => {
    try {
      const response: any = await authApi.post(
        `/v2/api/myobadvanced/syncEmployees`,
        { companyId: selectedCompanyId }
      );
      if (response?.data) {
        toast(response?.data?.message || T.SYNCED_SUCCESSFULLY, { variant: "success" });
      }
    } catch (error: any) {
      toast(error?.response?.data?.message || error?.message || "Failed to sync MYOB Advanced payroll", { variant: "error" });
    }
  };
}

// ==============================|| SLICE - Sync Deputy Payroll Settings ||============================== //

export function syncDeputyPayroll() {
  return async () => {
    try {
      const response: any = await v1Api.get(
        `/api/timesheets/deputy/syncDataOfDeputyServiceUI`
      );
      if (response?.data) {
        toast(response?.data?.result || T.SYNCED_SUCCESSFULLY, { variant: "success" });
      }
    } catch (error: any) {
      toast(error?.message || error?.result || "Failed to trigger Deputy sync", { variant: "error" });
    }
  };
}
